<template>
  <div>
    <el-card body-style="padding: 0" v-if="report_date" v-loading="detailLoading">
      <div slot="header" class="card_header">
        <span>{{ report_date }}</span>
        <el-input class="w-200px" v-model="search" size="mini" placeholder="搜尋"/>
      </div>
      <ezoom-table
          :data="detailData"
          :columns="detailColumns"
          :search="search">
        <template slot="buttons">
          <!-- <el-button v-if="isToday" @click.stop="openDialog({},'add')"
                     type="primary" size="small" icon="el-icon-plus">
            新增
          </el-button> -->
        </template>
        <el-table-column
            fixed="left"
            label="操作"
            width="100">
          <template slot-scope="scope">
            <el-button @click.stop="openDialog(scope.row,'update')" type="warning"
                       size="small" icon="el-icon-edit"/>
            <el-popconfirm title="確定要刪除此打卡資料嗎？"
                           @onConfirm="del(scope.row)"
                           @onCancel="()=>{}"
                           confirmButtonText="確定"
                           cancelButtonText="取消">
              <el-button @click.stop="" slot="reference" type="danger"
                         size="small" icon="el-icon-delete"/>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column prop="department" sortable label="部門" />
        <el-table-column prop="employee_id" sortable label="員工編號" />
        <el-table-column prop="user_name" sortable label="姓名" />
        <el-table-column prop="checkStatusLabel" sortable label="打卡狀態" />
        <el-table-column prop="actionLabel" sortable label="動作" />
        <el-table-column prop="checkinDateStr" sortable label="打卡時間" />
        <el-table-column prop="place" sortable label="打卡地點" />
      </ezoom-table>
    </el-card>
    <el-card v-else v-loading="detailLoading">
      請選擇左方任一筆統計資料 , 查看詳細內容
    </el-card>
    <crud-checkinLog
        ref="crudDialog"
        :add-fn="add"
        :update-fn="update"
        :employees="employees"/>
  </div>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import EzoomTable from "@/components/EzoomTable";
import CrudCheckinLog from "./CrudCheckinLog.vue";
import DateUtil from "@/utils/dateUtil";
import MessageService from "@/components/Message";
import LoadingService from "@/components/Loading";
import CheckinLogService from "@/api/checkinLog";
import EmployeeService from "@/api/employee";

const data = ref([]);
const employees = ref([]);
const all_emps = ref([]);
const dateRef = ref(null);
const departmentRef = ref(null);
const detailLoading = ref(false);
const Transformer = (array = []) => {
  return array.map(single => {

    var checkTypeLabel = '';
    if (single.check_type === 'P1') {
      checkTypeLabel = '上下班打卡';
    } else if (single.check_type === 'P2') {
      checkTypeLabel = '加班打卡';
    } else if (single.check_type === 'P3') {
      checkTypeLabel = '出公差打卡';
    }

    var action_label = '';
    if (single.action === 'P0') {
      action_label = '未打卡動作';
    } else if (single.action === 'P1') {
      action_label = '上班';
    } else if (single.action === 'P2') {
      action_label = '下班';
    } else if (single.action === 'P3') {
      action_label = '加班開始打卡';
    } else if (single.action === 'P4') {
      action_label = '加班結束打卡';
    } else if (single.action === 'P5') {
      action_label = '出公差開始打卡';
    } else if (single.action === 'P6') {
      action_label = '出公差結束打卡';
    }

    var check_status_label = '';
    if (single.check_status === 'P1') {
      check_status_label = '未打卡';
    } else if (single.check_status === 'P2') {
      check_status_label = '已打卡';
    }

    var checkinDateStr = null;
    if (single.checkin_date) {
      checkinDateStr = DateUtil.format(single.checkin_date, "YYYY-MM-DD HH:mm:ss");
    }
    
    return {
      ...single,
      checkTypeLabel: checkTypeLabel,
      actionLabel: action_label,
      checkStatusLabel: check_status_label,
      checkinDateStr: checkinDateStr,
      employee_id: single.employee_id,
      user_name: single.employee_name,
      department: single.department
    };
  });
};
export const getDetailData = async ({date, department}) => {

  try {

    // loading start
    detailLoading.value = true;

    const checkinLogs = await CheckinLogService.reportedCheckinLogWithDept({date, department});
    data.value = Transformer(checkinLogs);
    employees.value = await CheckinLogService.getUnReports({date, department});
    all_emps.value = await EmployeeService.list(department);
    dateRef.value = date;
    departmentRef.value = department;

    // loading end
    detailLoading.value = false;

    console.log('getDetailData...');
    console.log(data);
    return data.value;

  } catch (e) {

    detailLoading.value = false;
    throw e;
  }
}

export default {
  name: "Detail",
  components: {
    'ezoom-table': EzoomTable,
    'crud-checkinLog': CrudCheckinLog,
  },
  setup() {

    const search = ref('');

    const checkinLog = ref(null);
    const crudDialog = ref(null);

    const detailColumns = ref([
      {label: "部門", prop: "department"},
      {label: "員工編號", prop: "employee_id"},
      {label: "姓名", prop: "user_name"},
      {label: "打卡狀態", prop: "checkStatusLabel"},
      {label: "動作", prop: "actionLabel"},
      {label: "打卡時間", prop: "checkinDateStr"},
      {label: "打卡地點", prop: "place"},
    ]);

    const isToday = computed(() => DateUtil.isSameDay(dateRef.value, new Date()));
    const report_date = computed(() => {

      const getReportDate = date => `${DateUtil.format(date, "YYYY/MM/DD")}(${DateUtil.getWeekDayStr(date)})`;
      return dateRef.value && getReportDate(dateRef.value);
    });

    const tableData = computed(() => data.value);

    const detailData = computed(() => {
      return tableData.value;
    });

    const openDialog = (...args) => crudDialog.value.openDialog(...args)

    return {
      search,
      checkinLog,
      detailLoading,
      detailColumns,
      isToday,
      report_date,
      tableData,
      employees,
      detailData,
      crudDialog,
      openDialog,
    };
  },
  methods: {

    // add . update . delete => getDetailData to fetch the new data
    async add() {

      // open the global loading mask
      LoadingService.open('新增打卡資料中...');

    },
    async update(checkinLog) {

      // open the global loading mask
      LoadingService.open('更新打卡回報資料中...');

      try {
        console.log('checkinLog update...');
        var checkTypeLabel = '';
        if (checkinLog.check_type === 'P1') {
          checkTypeLabel = '上下班打卡';
        } else if (checkinLog.check_type === 'P2') {
          checkTypeLabel = '加班打卡';
        } else if (checkinLog.check_type === 'P3') {
          checkTypeLabel = '出公差打卡';
        }

        var action_label = '';
        if (checkinLog.action === 'P0') {
          action_label = '未打卡動作';
        } else if (checkinLog.action === 'P1') {
          action_label = '上班';
        } else if (checkinLog.action === 'P2') {
          action_label = '下班';
        } else if (checkinLog.action === 'P3') {
          action_label = '加班開始打卡';
        } else if (checkinLog.action === 'P4') {
          action_label = '加班結束打卡';
        } else if (checkinLog.action === 'P5') {
          action_label = '出公差開始打卡';
        } else if (checkinLog.action === 'P6') {
          action_label = '出公差結束打卡';
        }

        var checkinDate = checkinLog.checkinDate;
        if (checkinDate) {
          checkinDate = DateUtil.format(checkinDate, "YYYY-MM-DD HH:mm:ss");
          checkinLog.checkin_date = checkinDate;
        }
        checkinLog.updateAt = DateUtil.format(new Date(), "YYYY-MM-DD HH:mm:ss");
        console.log(checkinLog);
        await CheckinLogService.update(checkinLog.id, checkinLog);
        await getDetailData({date: dateRef.value, department: departmentRef.value});
        MessageService.success(`打卡資料，成功修改： *員編* ${checkinLog.employee_id} - *打卡* ${checkTypeLabel}-${action_label}`);

      } catch (e) {

        MessageService.error(`錯誤提示：${e.title} , ${e.message}`);

      } finally {

        LoadingService.close();
      }
    },

    del(checkinLog) {

      CheckinLogService.deleteById(checkinLog.id)
          .then(() => getDetailData({date: dateRef.value, department: departmentRef.value}))
          .then(() => MessageService.success(`打卡資料，成功刪除： *員編* ${checkinLog.employee_id} - *打卡* ${checkinLog.checkTypeLabel}-${checkinLog.actionLabel}`))
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    },

    dateFormatter(row, column /* , cellValue, index */) {
        const date = row[column.property];
        return DateUtil.format(date, "YYYY-MM-DD HH:mm:ss");
    },
  },
}
</script>

<style scoped>
</style>
